import { Home } from "@mui/icons-material";
import { styled } from "@mui/material";
import React from "react";

const BreadDiv = styled("div")(({ theme }) => ({
  marginBottom: "10px",
  "& span": {
    color: "#999",
    cursor: "pointer",
    fontSize: "14px",
  },

  "& span:hover": {
    textDecoration: "underline",
  },
  "& small": {
    fontSize: "12px"
  },
  "& svg": {
    fontSize: "19px",
    position: "relative",
    top: "4px",
    right: "-2px"
  },
}));

const BreadCrumb = ({
  step,
  setStep,
  title1,
  title2,
  title3,
  title4,
  title5,
  customerDetails, setCustomerDetails
}) => {

  const handleStep0 = () => {
    setStep(0);
    setCustomerDetails({
      ...customerDetails,
      type: "",
      fullName: "",
      clientName: "",
      customerID: "",
      salesDocumentID: "",
      firstName: "",
      lastName: "",
      mobile: "",
      email: "",
      notify: false,
      school: "",
      schoolID: "",
      schoolID1: "",
      grade: "",
      gender: "",
      quantity: [],
      cart: 0,
      cartTotal: "",
      cartItems: [],
    })
  }

  const handleStep1 = () => {
    if(customerDetails.type === "resume" || customerDetails.type === "existing"){
      setStep(0);
    }else{
      setStep(1)
    }
  }


  return (
    <BreadDiv>
      <span onClick={handleStep0}> <Home fontSize="small" /> </span>

      {title1 && <small> / </small>}
      {title1 && <span onClick={handleStep1}>{title1}</span>}

      {title2 && <small> / </small>}
      {title2 && <span onClick={() => setStep(2)}>{title2}</span>}

      {title3 && <small> / </small>}
      {title3 && <span onClick={() => setStep(3)}>{title3}</span>}

      {/* {title4 && <small> / </small>}
      {title4 && <span onClick={() => setStep(4)}>{title4}</span>} */}

      {/* {title5 && <small> / </small>}
      {title5 && <span onClick={() => setStep(5)}>{title5}</span>} */}

      {title5 && <small> / </small>}
      {title5 && <span>{title5}</span>}
    </BreadDiv>
  );
};

export default BreadCrumb;
